import React, { useCallback, useEffect, useState } from 'react'
import TableBody from '../TableParts/TableBody';
import { cartCartSelector, cartMainProduct } from '../../redux/selectors/cartSelector';
import { connect } from 'react-redux';
import { includeExtra, includeProduct } from '../../redux/actions/cartAction';
import TableDiscount from '../TableParts/TableDiscount';
import { useFilters } from '../../hooks/useFilters';
import cn from 'classnames';
import getDiscountDaysByProduct from '../../resolvers/getDiscountDaysByProduct';
import {
    productCurrentProductIdSelector,
    productProductsSelector,
} from '../../redux/selectors/productSelector';
import { showWarning } from '../../lib/toast';
import isProductInclusionAllowed from '../../resolvers/isProductInclusionAllowed';
import { pagesTariffsByProductSelector } from '../../redux/selectors/pagesSelectors';

function FeaturedProductItem({
    product,
    id,
    cart,
    includeProduct,
    mainProduct,
    includeExtra,
    products,
    tariffListByProduct,
    productCurrentProductId,
    productTotal
}) {

    const [isAvailableFeaturedOption, setIsAvailableFeaturedOption] = useState(false);
    const warningInclusionMessages = `Featured product "${product.product_name}" is not available for selected Period or Package. Please check the package limits.`;

    useFilters(product, product?.product_id);

    const [services, setServices] = useState(0);

    useEffect(() => {
        if (
            mainProduct?.current_tariff_id &&
            tariffListByProduct[mainProduct?.current_tariff_id] &&
            tariffListByProduct[mainProduct?.current_tariff_id].services
        ) {
            setServices(tariffListByProduct[mainProduct?.current_tariff_id].services);
        }
    }, [mainProduct, tariffListByProduct]);

    const handleProductInclusion = useCallback(
        (value, transitiveUpdate) => {
            const flag = isProductInclusionAllowed(product, mainProduct, cart);
            if (value && !flag && !transitiveUpdate) {
                showWarning('auto-switch-off-featured-product', warningInclusionMessages);
            }

            setIsAvailableFeaturedOption(flag);
            includeProduct({ value: value, product_id: product?.product_id, change: true });
        },
        [product, mainProduct, cart, includeProduct, warningInclusionMessages]
    );

    useEffect(() => {
        const flag = isProductInclusionAllowed(product, mainProduct, cart);
        setIsAvailableFeaturedOption(flag);
        includeProduct({
            value: Boolean(product?.isIncluded && flag),
            product_id: product?.product_id,
            change: true,
        });

    }, [product, products, mainProduct, cart, handleProductInclusion, includeProduct]);

    return (
        <div
            hidden={productTotal <= 0}
            className={cn('section__row section__row--featured', {
                'is-active': product?.isIncluded && isAvailableFeaturedOption,
                'not-available': !isAvailableFeaturedOption,
            })}
        >
            <div className="checkbox checkbox--featured mt-16 ml-16 tablet-ml-0 tablet-mt-13">
                <input
                    type="checkbox"
                    id={id}
                    className="checkbox__input"
                    checked={!!product?.tariff && product?.isIncluded && isAvailableFeaturedOption}
                    onChange={(e) => handleProductInclusion(e.target.checked)}
                />
                <label htmlFor={id} className="checkbox__label">
                    <span className={'hidden'}>text</span>
                </label>
            </div>
            <section
                className={`section--table section--featured section--table--${cart?.currency?.currency?.toLowerCase()}`}
            >
                <TableBody
                    product={product}
                    product_id={product?.product_id}
                    currency={cart?.currency}
                    includeExtra={includeExtra}
                />
                {!!getDiscountDaysByProduct(product) && (
                    <TableDiscount
                        product_id={product?.product_id}
                        product={product}
                        currency={cart?.currency}
                        services={services}
                        productCurrentProductId={productCurrentProductId}
                    />
                )}
            </section>
        </div>
    );
}

const mapStateToProps = (state) => ({
    cart: cartCartSelector(state),
    mainProduct: cartMainProduct(state),
    products: productProductsSelector(state),
    tariffListByProduct: pagesTariffsByProductSelector(state),
    productCurrentProductId: productCurrentProductIdSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    includeProduct: (value) => dispatch(includeProduct(value)),
    includeExtra: (value) => dispatch(includeExtra(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedProductItem);
